import {
  usePrevApPayeeIsBankTransfer,
  useSelectedApPayeeIsBankTransfer,
} from '@/components/ApPayee/useChangeIsBankTransfer';
import { useEffect } from 'react';
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { PaymentRequestForm } from '../../../../type';

export const useUpdateForCurrencyAndRate = (
  getValues: UseFormGetValues<PaymentRequestForm>,
  setValue: UseFormSetValue<PaymentRequestForm>
) => {
  const isBankTransfer = useSelectedApPayeeIsBankTransfer();
  const isPrevDisabled = usePrevApPayeeIsBankTransfer();

  useEffect(() => {
    if (!isBankTransfer && isPrevDisabled) {
      const invoiceTransactions = getValues('invoiceTransactions');
      const updatedTransactions = invoiceTransactions.map((transaction) => ({
        ...transaction,
        currency: 'JPY',
        jpyRate: 1,
      }));
      setValue('invoiceTransactions', updatedTransactions);
    }
  }, [getValues, isBankTransfer, isPrevDisabled, setValue]);
};
